// src/components/Resume.js
import React from 'react';

const Gentelman = () => {
  return (
    <div>
      <h1>Gentelman Page</h1>
      <p>This is the Gentelman page content.</p>
    </div>
  );
};

export default Gentelman;